'use client';
import { config } from '@/apollo/config';
import { BANNER_LIST_QUERY } from '@/apollo/graphql/queries/bannerQueries/bannerQueries';
import IconArrowLeft from '@/assets/icons/drawer-icons/icon-arrow-left.svg';
import { Link } from '@/i18n/navigation';
import { useQuery } from '@apollo/client';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import Image from 'next/image';
import { SetStateAction, useEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './carousel.module.scss';
import './splide.css';

type Props = {};

const CustomCarousel = (props: Props) => {
  const splideRef = useRef<any>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const { data: bannerData, loading } = useQuery(BANNER_LIST_QUERY, {
    variables: { first: 100, filter: { bannerType: 'MAIN_TOP' } },
  });

  useEffect(() => {
    // Add event listener to update the current slide index when slides change
    const splide = splideRef.current?.splide;
    if (splide) {
      splide.on('moved', (newIndex: SetStateAction<number>) => {
        setCurrentSlide(newIndex);
      });
    }

    return () => {
      if (splide) {
        splide.off('moved');
      }
    };
  }, []);

  return (
    <div className={styles.carousel}>
      <Splide
        ref={splideRef}
        options={{
          updateOnMove: true,
          type: 'loop',
          width: '1118px',
          perPage: 4,
          perMove: 1,
          rewind: true,
          rewindByDrag: true,
          arrows: true,
          pagination: false,
          gap: '12px',
          breakpoints: {
            1200: {
              perPage: 3,
            },
            1024: {
              perPage: 3,
            },
            768: {
              perPage: 3,
              gap: '8px',
            },
            480: {
              perPage: 2,
              gap: '8px',
            },
            375: {
              perPage: 3,
              gap: '8px',
            },
          },
        }}
        hasTrack={false}
        style={{ padding: '0' }}
      >
        {loading ? (
          <SplideTrack>
            {Array.from({ length: 11 }).map((_, index) => (
              <SplideSlide key={index}>
                <div className={`${styles.skeletonForSidebarImg}`}>
                  <Skeleton />
                </div>
              </SplideSlide>
            ))}
          </SplideTrack>
        ) : (
          <SplideTrack>
            {bannerData?.banners?.edges.map((item: any) => (
              <SplideSlide key={item.node.id}>
                <div className={styles.slide}>
                  <Link href={item?.node?.url || '#'} passHref>
                    <Image
                      className={styles.carouselImage}
                      src={`${config.publicApiUrl}${item?.node?.image}`}
                      alt={item?.node?.title}
                      layout="responsive"
                      priority
                      width={271}
                      height={432}
                    />
                  </Link>
                </div>
              </SplideSlide>
            ))}
          </SplideTrack>
        )}
        {loading ? (
          <div
            className="splide__arrows"
            style={{ transform: 'rotate(180deg)' }}
          >
            <button className="splide__arrow splide__arrow--prev">
              <IconArrowLeft />
            </button>
            <button
              style={{ right: '5px' }}
              className="splide__arrow splide__arrow--next"
            >
              <IconArrowLeft />
            </button>
          </div>
        ) : bannerData?.banners?.edges.length > 0 ? (
          <div
            className="splide__arrows"
            style={{ transform: 'rotate(180deg)' }}
          >
            <button className="splide__arrow splide__arrow--prev">
              <IconArrowLeft />
            </button>
            <button
              style={{ right: '5px' }}
              className="splide__arrow  splide__arrow--next"
            >
              <IconArrowLeft />
            </button>
          </div>
        ) : null}

        <div className={styles.customPagination}>
          {bannerData?.banners?.edges.map((_: any, index: number) => (
            <div
              key={index}
              className={`${styles.paginationDot} ${currentSlide === index ? styles.active : ''}`}
              onClick={() => splideRef.current?.splide.go(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </Splide>
    </div>
  );
};

export default CustomCarousel;
